import Cookies from 'js-cookie'

//存和取token
export const TOKEN_KEY = 'token'

export const setToken = (token, exp) => {    
    Cookies.set(TOKEN_KEY, token, {
        expires: exp
    })
}

export const getToken = () => {
    
    let  token = Cookies.get(TOKEN_KEY)
    if (token =='undefine' || token =='') {
        //   setToken('')
        return false
    } else {
        return token
    }
}
